import Image from "next/image";
import { useEffect, useState } from "react";
import { fetchGetCompanyBusinessHours, fetchGetCompanySiteSettings } from "../../../services/api";

export default function Footer({ company }) {

    const [businessHours, setBusinessHours] = useState([]);

    useEffect(() => {
        const fetchBusinessHours = async () => {
            const hours = [];
            try {
                const res = await fetchGetCompanyBusinessHours();
                if (res.monday && res.tuesday && res.wednesday && res.thursday && res.friday) {
                    const sameWeekdayHours =
                        res.mondayOpeningTime === res.tuesdayOpeningTime &&
                        res.mondayOpeningTime === res.wednesdayOpeningTime &&
                        res.mondayOpeningTime === res.thursdayOpeningTime &&
                        res.mondayOpeningTime === res.fridayOpeningTime &&
                        res.mondayClosingTime === res.tuesdayClosingTime &&
                        res.mondayClosingTime === res.wednesdayClosingTime &&
                        res.mondayClosingTime === res.thursdayClosingTime &&
                        res.mondayClosingTime === res.fridayClosingTime;

                    if (sameWeekdayHours) {
                        hours.push({ name: 'Segunda à Sexta', openingTime: res.mondayOpeningTime.slice(0, 5), closingTime: res.mondayClosingTime.slice(0, 5) });
                    } else {
                        if (res.monday) {
                            hours.push({ name: 'Segunda-feira', openingTime: res.mondayOpeningTime.slice(0, 5), closingTime: res.mondayClosingTime.slice(0, 5) });
                        }
                        if (res.tuesday) {
                            hours.push({ name: 'Terça-feira', openingTime: res.tuesdayOpeningTime.slice(0, 5), closingTime: res.tuesdayClosingTime.slice(0, 5) });
                        }
                        if (res.wednesday) {
                            hours.push({ name: 'Quarta-feira', openingTime: res.wednesdayOpeningTime.slice(0, 5), closingTime: res.wednesdayClosingTime.slice(0, 5) });
                        }
                        if (res.thursday) {
                            hours.push({ name: 'Quinta-feira', openingTime: res.thursdayOpeningTime.slice(0, 5), closingTime: res.thursdayClosingTime.slice(0, 5) });
                        }
                        if (res.friday) {
                            hours.push({ name: 'Sexta-feira', openingTime: res.fridayOpeningTime.slice(0, 5), closingTime: res.fridayClosingTime.slice(0, 5) });
                        }
                    }
                }
                if (res.saturday) {
                    hours.push({ name: 'Sábado', openingTime: res.saturdayOpeningTime.slice(0, 5), closingTime: res.saturdayClosingTime.slice(0, 5) });
                }
                if (res.sunday) {
                    hours.push({ name: 'Domingo', openingTime: res.sundayOpeningTime.slice(0, 5), closingTime: res.sundayClosingTime.slice(0, 5) });
                }
                if (res.holiday) {
                    hours.push({ name: 'Feriado', openingTime: res.holidayOpeningTime.slice(0, 5), closingTime: res.holidayClosingTime.slice(0, 5) });
                }
                setBusinessHours(hours);
            } catch (error) {
                console.error('Erro ao buscar os horários de funcionamento:', error);
            }
        };

        fetchBusinessHours();
    }, []);

    const [activePages, setActivePages] = useState([])
    useEffect(() => {
        const pages = []
        fetchGetCompanySiteSettings()
            .then(res => {
                res.showNew === true ? pages.push({ route: "novos", name: "0 Km" }) : null;
                res.showUsed === true ? pages.push({ route: "estoque", name: "Estoque" }) : null;
                res.showArmored === true ? pages.push({ route: "blindados", name: "Blindados" }) : null;
                res.showFinancing === true ? pages.push({ route: "financiamento", name: "Financiamento" }) : null;
                res.showVehiclePurchase === true ? pages.push({ route: "venda-seu-veiculo", name: "Venda seu Veículo" }) : null;
                res.showInsurance === true ? pages.push({ route: "seguro", name: "Seguro" }) : null;
                setActivePages(pages)
            })
    }, [])

    const formatPhone = (phone) => {
        if (!phone) return null;

        if (phone.length === 10) {
            return `(${phone.substring(0, 2)}) ${phone.substring(2, 6)}-${phone.substring(6, 10)}`;
        }

        if (phone.length === 11) {
            return `(${phone.substring(0, 2)}) ${phone.substring(2, 7)}-${phone.substring(7, 11)}`;
        }

        return phone;
    };

    const cnpjMask = (number) => {
        number.replace(/\D/g, '');
        return number.replace(/^(\d{2})(\d{3})?(\d{3})?(\d{4})?(\d{2})?/, "$1. $2. $3/$4-$5")
    }

    return (
        <>
            <footer className="footer-section">
                <div className="footer-wrapper pt-120 position-relative z-1 overflow-hidden">
                    <Image
                        src={'/img/shapes/texture-bg.png'}
                        alt="rodape"
                        width={1920}
                        height={1080}
                        style={{
                            zIndex: -1,
                            objectFit: 'cover',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%'
                        }}
                    />
                    <div className="container">
                        <div className="row justify-content-between">
                            <div className="col-xl-4 col-lg-4">
                                <div className="footer-widget widget-basic">
                                    <h3 className="widget-title-large mb-4 text-white">Tem alguma dúvida? Fale conosco e te ajudamos...</h3>
                                    <p className="mb-40">Nossos vendedores possuem anos de experiência para tirar todas suas dúvidas e te dar o melhor atendimento do Brasil.</p>
                                    <a href={`mailto:${company.email}`}><p class="text-white mb-5"><b>Email :</b> {company.email}</p></a>
                                    <div className="phone-box d-flex align-items-start flex-direction-column gap-3">
                                        {company.phone && (
                                            <div className="d-flex align-items-center">
                                                <span className="icon-wrapper d-inline-flex align-items-center justify-content-center rounded-circle bg-primary text-white">
                                                    <i className="flaticon-phone-call"></i>
                                                </span>
                                                <div>
                                                    <a href={`tel:+55${company.phone}`}>
                                                        <h4 className="text-white ms-3 mb-0">
                                                            {formatPhone(company.phone)}
                                                        </h4>
                                                    </a>
                                                </div>
                                            </div>
                                        )}
                                        {company.phone2 && (
                                            <div className="d-flex align-items-center">
                                                <span className="icon-wrapper d-inline-flex align-items-center justify-content-center rounded-circle bg-primary text-white">
                                                    <i className="flaticon-phone-call"></i>
                                                </span>
                                                <div>
                                                    <a href={`tel:+55${company.phone2}`}>
                                                        <h4 className="text-white ms-3 mb-0">
                                                            {formatPhone(company.phone2)}
                                                        </h4>
                                                    </a>
                                                </div>
                                            </div>
                                        )}
                                        {/* <div>
                                            <p className="text-white">CNPJ : {cnpjMask(company.cnpj)}</p>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-7 col-lg-7">
                                <div className="ms-lg-5 ms-xl-0 mt-5 mt-lg-0">
                                    <div className="row mt-30">
                                        <div className="col-sm-3">
                                            <div className="footer-widget footer-nav-widget mb-5 mb-sm-0">
                                                <div className="widget-title text-white mb-3 h6">Sobre Nós</div>
                                                <ul className="footer-nav">
                                                    <li><a href="/sobre-nos">Sobre</a></li>
                                                    <li><a href="/contato">Contato</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="footer-widget footer-nav-widget mb-5 mb-sm-0">
                                                <div className="widget-title text-white mb-3 h6">Links Rápidos</div>
                                                <ul className="footer-nav">
                                                    {activePages.map((page, index) => (
                                                        <li key={index}><a href={`/${page.route}`}>{page.name}</a></li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="col-sm-2 mb-5">
                                            <div className="text-white h6">Siga-nos</div>
                                            <ul className="footer-social-list">
                                                {company.youtube ? <li><a className="text-white" href={company.youtube} target={'_blank'} rel="noreferrer" aria-label="Acesse o youtube da nossa loja"><i className="fab fa-youtube"></i></a></li> : null}
                                                {company.facebook ? <li><a className="text-white" href={company.facebook} target={'_blank'} rel="noreferrer" aria-label="Acesse o facebook da nossa loja"><i className="fab fa-facebook-f"></i></a></li> : null}
                                                {company.instagram ? <li><a className="text-white" href={company.instagram} target={'_blank'} rel="noreferrer" aria-label="Acesse o instagram da nossa loja"><i className="fab fa-instagram"></i></a></li> : null}
                                                {company.tiktok ? <li><a className="text-white" href={company.tiktok} target={'_blank'} rel="noreferrer" aria-label="Acesse o tiktok da nossa loja"><i className="fab fa-tiktok"></i></a></li> : null}
                                            </ul>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="widget-title text-white mb-3 h6">Horário de Funcionamento</div>

                                            <div className="footer-social d-inline-block text-start">
                                                <ul className="footer-nav">
                                                    {businessHours.map((hour, index) => (
                                                        <div key={index} style={{ fontSize: "14px", color: "#FFFBFB" }}>{hour.name} : {hour.openingTime} - {hour.closingTime}</div>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="footer-copyright">
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-sm-7">
                                    <div className="copyright-text">
                                        <p className="mb-0">&copy; Todos os direitos reservados. Desenvolvido por &nbsp;&nbsp;<a href="https://bndv.com.br" target="_blank" rel="noreferrer">BNDV - Banco Nacional de Veículos</a></p>
                                    </div>
                                </div>
                                <div className="col-sm-5">
                                    <div className="copyright-links text-start text-sm-end mt-1 mt-sm-0">
                                        <a href="/termos">Termo de Uso e Política de Privacidade</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}